import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-74c9e283")

_pushScopeId("data-v-74c9e283")
const _hoisted_1 = { class: "DateCalendar" }
const _hoisted_2 = { class: "DateCalendar__wrap" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "DateCalendar__header" }, [
  /*#__PURE__*/_createVNode("div", { class: "header__title" }, "Выберите дату и период отправки")
], -1)
const _hoisted_4 = { class: "content__calendar" }
const _hoisted_5 = {
  key: 0,
  class: "content__result"
}
const _hoisted_6 = { class: "result__day" }
const _hoisted_7 = { class: "result__date" }
const _hoisted_8 = { class: "date__number" }
const _hoisted_9 = { class: "date__month" }
const _hoisted_10 = { class: "result__period" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Период не указан ")
const _hoisted_12 = {
  key: 0,
  class: "result__warning"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Сбросить ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Подтвердить ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_calendar = _resolveComponent("s-calendar")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", {
        class: ["DateCalendar__content", { 'content--full': Boolean(_ctx.state.date) }]
      }, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_s_calendar, {
            class: "primary",
            disabled: _ctx.disabled || _ctx.setted,
            "with-time": false,
            "with-periods": true,
            date: _ctx.state.date,
            "onUpdate:date": [
              _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.date = $event)),
              _ctx.onUpdateDate
            ],
            period: _ctx.state.period,
            "onUpdate:period": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.period = $event))
          }, null, 8, ["disabled", "date", "period", "onUpdate:date"])
        ]),
        (_ctx.state.date)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.getDayName(_ctx.state.date.getDay())), 1),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.state.date.getDate()), 1),
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.getMonthName(_ctx.state.date.getMonth())), 1)
              ]),
              _createVNode("div", _hoisted_10, [
                (_ctx.state.period)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.state.period.name), 1)
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_11
                    ], 64))
              ]),
              (_ctx.isShowWarning)
                ? (_openBlock(), _createBlock("div", _hoisted_12, " Вы не работаете в этот день. Вы уверены, что хотите выбрать эту дату? "))
                : _createCommentVNode("", true),
              (_ctx.setted)
                ? (_openBlock(), _createBlock(_component_new_button, {
                    key: 1,
                    disabled: _ctx.disabled,
                    class: "button--primary button--small button--outline",
                    onClick: _ctx.onReset
                  }, {
                    default: _withId(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : (_openBlock(), _createBlock(_component_new_button, {
                    key: 2,
                    loading: _ctx.schedule_state.is_loading,
                    disabled: _ctx.isCantSubmit,
                    class: "button--primary button--small",
                    onClick: _ctx.onSubmit
                  }, {
                    default: _withId(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"]))
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
})